// extracted by mini-css-extract-plugin
export default {"active":"LeftNavTeamTab_active__94zQ7","inactive":"LeftNavTeamTab_inactive__gb3Jq","addButton":"LeftNavTeamTab_addButton__UfiiD","addIcon":"LeftNavTeamTab_addIcon__tglB7"};